import script from "./LoginAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginAuth.vue?vue&type=script&setup=true&lang=ts"

import "./LoginAuth.vue?vue&type=style&index=0&id=1eae2ec2&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eae2ec2"]])

export default __exports__